/**
 * Achievements, derived
 * from the same facts a member shares in their summary, so a member's detail and the
 * person's own Account agree. Copy lives in the screens.
 */
export type AchievementKey =
  | 'new-member'
  | 'week-1'
  | 'sessions-30'
  | 'all-exercises'
  | 'streak-21'
  | 'sessions-60';

/** In the order the Figma lists them. */
export const ACHIEVEMENT_KEYS: readonly AchievementKey[] = [
  'new-member',
  'week-1',
  'sessions-30',
  'all-exercises',
  'streak-21',
  'sessions-60',
];

/** What an achievement is judged on — a member's shared summary or the person's own stats. */
export interface AchievementInput {
  /** Days on which the whole routine was done. */
  sessionsTotal?: number;
  /** Sessions expected in a week (the "of 5"). */
  target: number;
  completionByKind: { read: number; write: number; math: number };
  bestStreak: number;
}

export function hasAchievement(input: AchievementInput, key: AchievementKey): boolean {
  const sessions = input.sessionsTotal ?? 0;
  switch (key) {
    // Earned by joining: the welcome badge everyone starts with.
    case 'new-member':
      return true;
    case 'week-1':
      return sessions >= input.target;
    case 'sessions-30':
      return sessions >= 30;
    case 'sessions-60':
      return sessions >= 60;
    case 'all-exercises':
      return (
        input.completionByKind.read > 0 &&
        input.completionByKind.write > 0 &&
        input.completionByKind.math > 0
      );
    case 'streak-21':
      return input.bestStreak >= 21;
  }
}

export function earnedAchievements(input: AchievementInput): AchievementKey[] {
  return ACHIEVEMENT_KEYS.filter((key) => hasAchievement(input, key));
}
